import {
  ActionLayout,
  Button,
  EmailInputController,
  Grid,
  TextFieldController,
} from '@alice-financial/pretext-ui'
import * as React from 'react'
import { Control } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { useAddAdminAndNotifyKyc, UseRequestKYCHelpOptions } from './useRequestKYCHelp'

type NewAdminInputsProps = {
  control: Control<{ firstName: string; lastName: string; email: string }>
  required: boolean
}

export const NewAdminInputs = ({ control, required }: NewAdminInputsProps) => {
  const intl = useIntl()
  return (
    <Grid container wrap="wrap" spacing={1}>
      <Grid size={6}>
        <TextFieldController
          control={control}
          name="firstName"
          autoComplete="off"
          label={intl.formatMessage({ id: 'profile.first_name_label' })}
          fullWidth
          required={required}
        />
      </Grid>
      <Grid size={6}>
        <TextFieldController
          control={control}
          name="lastName"
          autoComplete="off"
          label={intl.formatMessage({ id: 'profile.last_name_label' })}
          fullWidth
          required={required}
        />
      </Grid>
      <Grid size={12}>
        <EmailInputController
          name="email"
          fullWidth
          autoFocus
          control={control}
          placeholder={intl.formatMessage({ id: 'profile.email.placeholder' })}
          required={required}
        />
      </Grid>
    </Grid>
  )
}

export const AddNewAdminForm = ({ org, onSuccess }: UseRequestKYCHelpOptions) => {
  const { onSubmit, control } = useAddAdminAndNotifyKyc({ org, onSuccess })
  return (
    <form onSubmit={onSubmit}>
      <NewAdminInputs control={control} required />
      <ActionLayout
        primary={
          <Button fullWidth variant="contained" type="submit">
            Invite
          </Button>
        }
      />
    </form>
  )
}
